<div class="bg-color-base-2500 h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11" class="text-align-center">
            <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>

            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                {{ "SuccessTitle" | translate }}
            </div>

            <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                {{ "SuccessMessage" | translate }}
            </div>

            <!-- <grid-row class="justify-content-center mt-50">
                <grid-col col="8">
                    <button class="btn-dft-border" (click)="continueApplication()">
                        {{ "SuccessButton" | translate }}
                    </button>
                </grid-col>
            </grid-row> -->
        </grid-col>
    </grid-row>
</div>
